<template>
  <div class="contain-overflow">
    <LaunchWidget/>
    <prebet-matches></prebet-matches>
  </div>
</template>

<script>
import PrebetMatches from '../Prebets/Matches.vue'
import Spinner from '../Shared/Spinner.vue'
import LaunchWidget from '../Shared/LaunchWidget.vue'

export default {
  name: 'home',
  components: {
    PrebetMatches,
    Spinner,
    LaunchWidget
  },
  metaInfo() {
    // Get environment configuration
    const store = this.$store || {};
    const stateEnv = store.state || {};
    const env = stateEnv.env || {};

    // Get country specific locale for canonical URL
    const countryCode = env.countryCode || '';
    const locale = (countryCode && countryCode.toLowerCase() === 'cd') ? 'fr-cd' : `en-${countryCode.toLowerCase()}`;
    const baseUrl = env.websiteUrl || window.location.origin;

    // Build the canonical URL with proper locale
    const canonicalUrl = `${baseUrl}/${locale}/`;

    // Build country-specific title
    const countryName = env.countryName || '';
    const title = countryName ?
      `Betika | Best Online Sports Betting in ${countryName}` :
      (env.websiteTitle || 'Betika | Best Online Sports Betting');

    // Create structured data for sportsbook
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "SportsActivityLocation",
      "name": title,
      "description": env.websiteDescription || 'Best Online Sports Betting site with instant deposits and withdrawals. Get the best odds and bonus offers.',
      "url": canonicalUrl,
      "potentialAction": {
        "@type": "ViewAction",
        "target": canonicalUrl
      }
    };

    return {
      title: title,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: env.websiteDescription || 'Best Online Sports Betting site with instant deposits and withdrawals. Get the best odds and bonus offers.'
        },
        {
          vmid: 'robots',
          name: 'robots',
          content: 'index, follow'
        },
        {
          vmid: 'googlebot',
          name: 'googlebot',
          content: 'index, follow'
        },
        {
          vmid: 'bingbot',
          name: 'bingbot',
          content: 'index, follow'
        },
        // Open Graph tags for social sharing
        {
          vmid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: env.websiteDescription || 'Best Online Sports Betting site with instant deposits and withdrawals. Get the best odds and bonus offers.'
        },
        {
          vmid: 'og:url',
          property: 'og:url',
          content: canonicalUrl
        },
        {
          vmid: 'og:type',
          property: 'og:type',
          content: 'website'
        },
        {
          vmid: 'og:image',
          property: 'og:image',
          content: env.websiteOpenGraphImage || ''
        },
        // Twitter card tags
        {
          vmid: 'twitter:card',
          name: 'twitter:card',
          content: 'summary_large_image'
        },
        {
          vmid: 'twitter:title',
          name: 'twitter:title',
          content: title
        },
        {
          vmid: 'twitter:description',
          name: 'twitter:description',
          content: env.websiteDescription || 'Best Online Sports Betting site with instant deposits and withdrawals. Get the best odds and bonus offers.'
        },
        // Add X-Robots-Tag as meta for servers that respect it
        {
          'http-equiv': 'X-Robots-Tag',
          content: 'index, follow'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: canonicalUrl
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: structuredData
        }
      ]
    };
  },
  mounted() {
    // Check if this is a catch-all route (404)
    if (this.$route && this.$route.matched &&
        this.$route.matched.length > 0 &&
        this.$route.matched[0].path === '*') {

      // Set HTTP status to 404 for SEO
      if (typeof document !== 'undefined') {
        // Create or update the status meta tag
        let statusMeta = document.querySelector('meta[name="status"]');
        if (!statusMeta) {
          statusMeta = document.createElement('meta');
          statusMeta.setAttribute('name', 'status');
          document.head.appendChild(statusMeta);
        }
        statusMeta.setAttribute('content', '404');

        // Add noindex for 404 pages
        let robotsMeta = document.querySelector('meta[name="robots"]');
        if (!robotsMeta) {
          robotsMeta = document.createElement('meta');
          robotsMeta.setAttribute('name', 'robots');
          document.head.appendChild(robotsMeta);
        }
        robotsMeta.setAttribute('content', 'noindex, nofollow');

        // Set page title
        const store = this.$store || {};
        const storeState = store.state || {};
        const env = storeState.env || {};
        document.title = 'Page Not Found | ' + (env.websiteTitle || 'Betika');

        console.log('404 Page Not Found: ' + window.location.pathname);

        // Report 404 to analytics if available
        if (this.$root && typeof this.$root.analyticsTrack === 'function') {
          try {
            this.$root.analyticsTrack('error', '404', {
              url: window.location.href,
              referrer: document.referrer
            });
          } catch (e) {
            console.error('Failed to track 404 error:', e);
          }
        }
      }
    }
  }
}
</script>
<style lang="scss">
.content {
	padding-bottom: var(--padding-bottom);
	max-width: var(--app-width);
	.nav {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		overflow: auto;
		margin-bottom: 5px;
		overflow-y: hidden; // hide vertical
		.selected {
			background-color: var(--yellow);
		}
		:first-child {
			margin-left: 5px;
		}
		&:last-child {
			margin-right: 10px;
		}
		&--item {
			height: 50px;
			display: block;
			min-width: 55px;
			background-color: var(--white);
			border: none;
			margin-right: 5px;
			border-radius: 5px;
			box-shadow: 0px 0px 10px -4px rgba(0, 0, 0, 0.75);
			line-height: 0.7;
			color: var(--black);
			&--icon {
				display: block;
				margin: 0 auto !important;
			}
			&--label {
				font-size: var(--font-smallest);
			}
		}
	}
}
</style>
